import React from 'react'
import { Modal } from 'antd'

export default function ServiceProviders({
  selectedService,
  isOpen,
  setIsOpen,
  providers,
}) {
  return (
    <Modal
      title={selectedService?.title}
      centered
      open={isOpen}
      onOk={() => setIsOpen(false)}
      onCancel={() => setIsOpen(false)}
      // hide footer
      footer={null}
    >
      <div>
        <h3>Choose a provider</h3>
        <div className='flex items-start justify-center gap-5 flex-wrap py-5'>
          {providers?.map((provider, index) => (
            <a
              key={index}
              href={provider?.book_url}
              className='px-4 py-2 rounded-lg border w-[200px] text-center bg-[#f5f5f5] hover:bg-[#e0e0e0] transition-all duration-300'
              target='_blank'
              rel='noopener noreferrer'
              onClick={() => {
                // window.open(provider?.book_url, '_blank')
                // window.location.href = provider?.book_url;
                // const link = document.createElement('a')
                // link.href = result?.book_url
                // link.target = '_blank'
                // link.rel = 'noopener noreferrer'
                // link.click()
                // setIsOpen(false)
              }}
            >
              {provider?.display_name || provider?.nick_name}
            </a>
          ))}
        </div>
      </div>
    </Modal>
  )
}
